import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgFill} from "~/assets/svg/fill.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmFillIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgFill id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
